export const PRODUCTS_TRACKS = {
  WISHLIST_ADD_ITEM: 'PRODUCTS__WISHLIST_ADD_ITEM',
  WISHLIST_REMOVE_ITEM: 'PRODUCTS__WISHLIST_REMOVE_ITEM',
};
